import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, Validators, FormGroup } from '@angular/forms';

import { EditFieldsModal } from '../modals/edit-fields-modal/edit-fields-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { SubjectService } from '../../services/subject.service';
import { LibService } from '../../services/libService';
import { ActionService } from '../../services/action.service';
import { NoopScrollStrategy } from '@angular/cdk/overlay';

@Component({
  selector: 'app-subject-edit-fields-button',
  templateUrl: './subject-edit-fields-button.component.html',
  styleUrls: ['./subject-edit-fields-button.component.scss']
})
export class SubjectEditFieldsButtonComponent implements OnInit {

  @Input() form: FormGroup;
  @Input() components: any;
  @Input() fieldsToActivate: any = [];
  @Input() options: any = {};

  constructor(
    private dialog: MatDialog,
    private subjectService: SubjectService,
    private libService: LibService,
    private actionService: ActionService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    //console.log('ngOnChanges subject edit fields button')
  }

  ngOnInit(): void {
    //console.log('ngOnInit subjetc edit fields button')
  }

  setDisabled() {
    return this.fieldsToActivate?.length == 0
  }

  buttonVisibility(){
    let id = this.form?.get('id')?.value
    return ![null, undefined, '', 0, '0'].includes(id) && this.checkPermissions("actions_can_always_edit_the_marketing_template_fields")
  }

  checkPermissions(key: string) {
    return this.actionService.checkPermissions(key)
  }

  openEditFieldsModal() {

    let dataStructure: any = {
      fieldsToActivate: this.fieldsToActivate,
      options: this.options,
    }

    const dialogRef = this.dialog.open(EditFieldsModal, {
      width: '400px',
      data: dataStructure,
      scrollStrategy: new NoopScrollStrategy(),
    });

    dialogRef.afterClosed().subscribe(result => {
      if (![null, undefined].includes(result)) {

        let subjectId = this.form?.get('id')?.value
        let attributes: any = {}
        this.fieldsToActivate.forEach((field: any) => {
          switch (field) {
            case 'marketingNoteId':
              attributes[field] = result[field]?.id;
              break;
            case 'origin':
              attributes[field] = result[field]?.origin
              break;
            case 'contactChannel':
              attributes[field] = result[field]?.name;
              break;
          }

        });

        this.libService.lockPage('');

        this.subjectService.editFields(subjectId, attributes).subscribe((res: any) => {
          this.fieldsToActivate.forEach((field: any) => {
            this.form.controls[field]?.patchValue(res[field])
          });
          this.libService.unlockPage();
        })




      }

    });
  }

}
